<h2 mat-dialog-title>
  {{ 'Log partecipante' | translate }}
  @if (data.participantDescription) {
    <small> — {{ data.participantDescription }}</small>
  }
</h2>

<mat-dialog-content class="logs-dialog-content">

  @if (loading) {
    <div class="loading-row">
      <mat-spinner [diameter]="28"></mat-spinner>
    </div>
  }

  @if (error && !loading) {
    <div class="error-row">
      {{ error | translate }}
    </div>
  }

  @if (!loading && !error && logs.length === 0) {
    <div class="empty-row">
      {{ 'Nessun log disponibile' | translate }}
    </div>
  }

  @if (!loading && !error && logs.length > 0) {
    <ul class="logs-list">
      @for (log of logs; track log) {
        <li class="log-item">
          <div class="log-meta">
            <span class="log-date">{{ log.created_at | date:'dd/MM/yyyy HH:mm:ss' }}</span>
            @if (log.user_name || log.user_email) {
              <span class="log-user">
                <span class="material-icons">person</span>
                {{ getUserLabel(log) }}
              </span>
            }
            <span class="log-type" [attr.data-type]="log.log_type">{{ getLogTypeLabel(log.log_type) | translate }}</span>
          </div>
          @if (log.user_message || log.message) {
            <div class="log-message">
              {{ log.user_message || log.message }}
            </div>
          }
          @if (getChangeSummary(log); as summary) {
            <div class="log-changes">
              {{ summary }}
            </div>
          }
        </li>
      }
    </ul>
  }

</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button (click)="close()">{{ 'Chiudi' | translate }}</button>
</mat-dialog-actions>
